const mediaItems = [
  {
    title: '暑期档必看十大佳片',
    desc: '这个夏天不容错过的精彩电影，从爆米花大片到文艺佳作，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20outdoor%20cinema%20with%20string%20lights%20and%20comfortable%20seating%2C%20large%20projector%20screen%20with%20soft%20glow%2C%20cozy%20atmosphere%2C%20golden%20hour%20warm%20lighting%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=media-summer&orientation=landscape',
    duration: '精选合集',
  },
  {
    title: '经典港片修复重映',
    desc: '高清修复版经典港片火热上线，重温黄金年代的银幕经典，画质升级情怀不变。',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20street%20scene%20with%20neon%20signs%20and%20vintage%20cinema%20marquee%2C%20warm%20nostalgic%20amber%20lighting%2C%20classic%20movie%20poster%20aesthetic%2C%20rain-slicked%20pavement%20reflecting%20colorful%20lights%2C%20cinematic%20composition&width=600&height=400&seq=media-hk&orientation=landscape',
    duration: '经典回眸',
  },
  {
    title: '高分动画电影巡礼',
    desc: '全球动画精品一网打尽，从宫崎骏到皮克斯，老少皆宜的视觉盛宴随时开启。',
    image: 'https://readdy.ai/api/search-image?query=Magical%20animation%20studio%20workspace%20with%20warm%20soft%20lighting%2C%20colorful%20sketches%20and%20storyboards%20on%20walls%2C%20whimsical%20creative%20atmosphere%2C%20gentle%20pastel%20color%20palette%2C%20artistic%20composition%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=media-anime&orientation=landscape',
    duration: '动画精选',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            精彩推荐
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            编辑精选影片专题，发现更多观影灵感
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="px-2.5 py-1 rounded-full bg-white/90 text-foreground-800 text-xs font-medium font-label">
                    {item.duration}
                  </span>
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-lg"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}